import { useEffect, useState } from "react";
import { getDrawerType } from "../functions";
import LoadingPage from "./Loading";
import { PopupIframe } from "./Popup";

export const Drawer = ({ openDrawer, setOpenDrawer, appVersion, currMaterials, model }) => {

    const [iframe, setIframe] = useState();
    const [isLoaded, setIsLoaded] = useState(false);

    const [modelLoading, setModelLoading] = useState(true);
    const [mtlLoading, setMtlLoading] = useState(true);

    function ViewerLoaded() {
        const type = getDrawerType(model, currMaterials);
        // console.log(type)
        iframe.loadDrawer(type, currMaterials)
        setIsLoaded(true);
    }



    function OnModelBegin() {
        setModelLoading(true)
    }
    function OnModelEnd() {
        setModelLoading(false)
    }
    function OnMaterialBegin() {
        setMtlLoading(true)
    }
    function OnMaterialEnd() {
        setMtlLoading(false)
    }

    useEffect(() => {
        iframe?.addEventListener("initiatedApp", ViewerLoaded, false);
        iframe?.addEventListener("onModelBegin", OnModelBegin, false);
        iframe?.addEventListener("onModelEnd", OnModelEnd, false);
        iframe?.addEventListener("onMaterialBegin", OnMaterialBegin, false);
        iframe?.addEventListener("onMaterialEnd", OnMaterialEnd, false);
        return () => {
            iframe?.removeEventListener("initiatedApp", ViewerLoaded);
            iframe?.removeEventListener("onModelBegin", OnModelBegin);
            iframe?.removeEventListener("onModelEnd", OnModelEnd);
            iframe?.removeEventListener("onMaterialBegin", OnMaterialBegin);
            iframe?.removeEventListener("onMaterialEnd", OnMaterialEnd);
        }
    }, [iframe])

    useEffect(() => {
        if (currMaterials) {
            iframe?.setDrawerMaterials(currMaterials)
        }
    }, [currMaterials])

    useEffect(() => {
        if (!openDrawer) {
            setIframe();
            setIsLoaded(false);
        }
        setModelLoading(openDrawer)
        setMtlLoading(openDrawer)
    }, [openDrawer])

    const iframeLoaded = (el) => {
        setIframe(el.contentWindow);
    }

    const closeDrawer = () => {
        setOpenDrawer(false);

    }

    return (
        <PopupIframe mobilePopup={openDrawer} setMobilePopup={closeDrawer}>
            <div onClick={(e) => e.stopPropagation()} id="drawerChild">
                {(modelLoading || mtlLoading) && <LoadingPage />}
                {/* <div onClick={() => closeDrawer()} className="bigX small"></div> */}
                {
                    openDrawer && <iframe
                        width={500}
                        height={500}
                        onLoad={(e) => iframeLoaded(e.target)}
                        src={`./app/${appVersion}/index.html?drawerMode=true`}
                        id="iframeDrawer"
                        className={!isLoaded ? "hidden" : ""}
                        allowFullScreen
                    ></iframe>
                }
            </div>
        </PopupIframe>
    )
}